import _extends from "@babel/runtime/helpers/extends";
import Container from "../common/Container.js";
import { Issues } from "./Issues.js";
import { Size } from "./Size.js";
import { License } from "./License.js";
import Downloads from "./Downloads.js";
import Activity from "./Activity.js";
import Version from "./Version.js";
import Analysis from "./Analysis.js";
import Social from "./Social.js";
import { jsx as _jsx } from "react/jsx-runtime";
var Github = props => /*#__PURE__*/_jsx(Container, _extends({}, props));
Github.Issues = Issues;
Github.Size = Size;
Github.Downloads = Downloads;
Github.License = License;
Github.Activity = Activity;
Github.Analysis = Analysis;
Github.Version = Version;
Github.Social = Social;
Github.displayName = 'Github';
export default Github;